import { StyledJobsPage, JobsPageInner } from './styles'
import JobsMain from './components/JobsMain'

function JobsPage() {
  return (
    <StyledJobsPage>
      <JobsPageInner>
        <JobsMain />
      </JobsPageInner>
    </StyledJobsPage>
  )
}

export default JobsPage
